module.exports = __webpack_public_path__ + "assets/img/solar-energy.f30c466a.jpg";